import styled, { keyframes } from "styled-components";

export const SwitcherContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px;
  width: 100%;
`;

export const TabSwitcherContainerLeft = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
`;

export const TabSwitcherContainerRight = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export const SwitcherContainerRight = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  height: 100%;
  gap: 8px;
`;
export const MenuWrapper = styled.div`
  position: relative;
  display: inline-block;

    & div[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 150px;
  margin-top: 4px;
`;

export const DropdownItem = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #f5f5f5;
  }
  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  &:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
  }
`;

export const WorkFlowProcessContainer = styled.div`
    display:flex;
    flex-direction: row;
    gap:8px;
`;

const spin = keyframes`
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
`;

export const CircularProgress = styled.div`
  border: 3px solid ${(props) => props.theme.colors.dividerGray};
  border-top: 3px solid  ${(props) => props.theme.colors.black};;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: ${spin} 0.8s linear infinite;
  display: inline-block;
`;